<div class="home-slides">
    <owl-carousel-o #carousel [options]="homeSlides">
        <ng-container *ngFor="let slide of settings.homePage.banner.slides; let i = index">
            <ng-template carouselSlide>
                <div class="hero-banner" [ngClass]="slide.bgClass" [style.backgroundImage]="'url(' + getSlideImage(i) + ')'">
                    <div class="container">
                        <div class="hero-banner-content" [ngClass]="slide.textAlign">
                            <h1 [innerHTML]="slide.title | linebreaks"></h1>
                            <p [innerHTML]="slide.description | linebreaks"></p>
                            <a [href]="slide.buttonUrl" class="btn btn-on-image">
                                {{ slide.buttonText }}
                            </a>
                        </div>
                    </div>
                </div>
            </ng-template>
        </ng-container>
    </owl-carousel-o>
</div>